import React, { useState, useEffect, useRef } from 'react';
import styles from './styles/LandingPage.module.css';

const images = [
  'https://d3lwdqji776yyc.cloudfront.net/HomeImages/srk%20in%20osbyos%20%40burjeel%20ad.webp',
  'https://d3lwdqji776yyc.cloudfront.net/OS+24/8+DOUBLE+BLACK+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20246190.webp',
  'https://d3lwdqji776yyc.cloudfront.net/HomeImages/20240806131242_0V8A1368+(1)+(1)-optimized+(1).webp',
];

const AUTOPLAY_INTERVAL = 5000;

const LandingPage = () => {
  const [current, setCurrent] = useState(0);
  const autoplayRef = useRef();

  const nextSlide = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  useEffect(() => {
    autoplayRef.current = nextSlide;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      autoplayRef.current();
    }, AUTOPLAY_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const contactButton = (e) => {
    e.stopPropagation();
    const message = encodeURIComponent(
      `I’m interested in booking a consultation for a bespoke tailoring experience. Please let me know the next available appointment.`
    );
    const url = `https://wa.me/919004007226?text=${message}`;
    window.open(url, "_blank");
  };

  return (
    <div className={styles.container}>
      {/* Right Side */}
      <div className={styles.right}>
        <div
          className={styles.textMask}
          style={{ backgroundImage: `url(${images[current]})` }}
        >
          OSBYOS<br></br>
          Luxury Menswear
        </div>
        <button
          onClick={contactButton}
          className={styles.contactButton}
          style={{ backgroundImage: `url(${images[current]})` }}
        >
          Arrange a Consultation
        </button>
      </div>

      {/* Left Side: Carousel & Text */}
      <div className={styles.left}>
        <div
          className={styles.carouselImage}
          style={{ backgroundImage: `url(${images[current]})` }}
        />
        <div className={styles.overlay}>
          <p className={styles.subheading}>Luxury Menswear</p>
          <p className={styles.punchline}>Tailored for Icons. Worn by Legends.</p>
        </div>

        {/* Navigation Buttons */}
        <button className={`${styles.navButton} ${styles.prev}`} onClick={prevSlide}>
          &lt;
        </button>
        <button className={`${styles.navButton} ${styles.next}`} onClick={nextSlide}>
          &gt;
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
